"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _urlHelper = _interopRequireDefault(require("../urlHelper"));

var _ENUMS = _interopRequireDefault(require("../ENUMS"));

var _clientIdHelper = _interopRequireDefault(require("../clientIdHelper"));

var getQueryString = _urlHelper["default"].getQueryString,
    replaceUrl = _urlHelper["default"].replaceUrl;
var WebViewConnect = (0, _createClass2["default"])(function WebViewConnect() {
  var _this = this;

  (0, _classCallCheck2["default"])(this, WebViewConnect);
  (0, _defineProperty2["default"])(this, "redirectUrl", function (url) {
    _this.allowKey.forEach(function (key) {
      var val = _this.getValue(key);

      if (val) {
        url = replaceUrl(url, key, val);
      }
    });

    location.href = url;
  });
  (0, _defineProperty2["default"])(this, "clear", function () {
    _this.storage.removeItem(_this.STORENAME);
  });
  (0, _defineProperty2["default"])(this, "getValue", function (key) {
    var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!_this.allowKey.includes(key)) {
      throw new Error("WebViewConnect getValue Error: \u65E0\u6548\u7684key".concat(key));
    }

    var data = _this.getQueryInfo();

    if (key === _this.KEYS.token) {
      return data[key] || localStorage.getItem('WEB_TOKEN') || defaultVal;
    } else {
      return data[key] || defaultVal;
    }
  });
  (0, _defineProperty2["default"])(this, "setValue", function (key, value) {
    var data = _this.getQueryInfo();

    data[key] = value;

    _this.storage.setItem(_this.STORENAME, JSON.stringify(data));
  });
  (0, _defineProperty2["default"])(this, "getClientId", function (defaultVal) {
    return _this.getQueryInfo()['Client-Id'] || _clientIdHelper["default"].getClientId(defaultVal);
  });
  (0, _defineProperty2["default"])(this, "getQueryInfo", function () {
    var res = {};

    try {
      res = _this.storage.getItem(_this.STORENAME) ? JSON.parse(_this.storage.getItem(_this.STORENAME)) : {};
    } catch (error) {
      res = {};
    }

    return res;
  });
  (0, _defineProperty2["default"])(this, "_init", function () {
    var oldAppStoreInfo = _this.getQueryInfo();

    var newObj = {};

    _this.allowKey.map(function (v) {
      var queryValue = getQueryString(v);
      newObj[v] = _this.wxMiniProgram ? queryValue : queryValue || oldAppStoreInfo[v];

      if (v === _this.KEYS.token && (getQueryString(_this.KEYS.isApp) || getQueryString(_this.KEYS.iss_source))) {
        var hasKey = queryValue === '' || queryValue;
        newObj[v] = hasKey ? queryValue : oldAppStoreInfo[v];
      }

      _this._joinClientId(newObj, v);

      if ([_this.KEYS.iss_source, _this.KEYS.isApp].includes(v) && queryValue) {
        _this._syncToken(newObj);
      }
    });

    _this.storage.setItem(_this.STORENAME, JSON.stringify(newObj));
  });
  (0, _defineProperty2["default"])(this, "_syncToken", function (newObj) {
    var token = getQueryString(_this.KEYS.token) || '';
    localStorage.setItem('WEB_TOKEN', token);
    newObj[_this.KEYS.token] = token;
  });
  (0, _defineProperty2["default"])(this, "_joinClientId", function (newObj, v) {
    if (v === _this.KEYS.iss_source) {
      var ISS_SOURCE = _ENUMS["default"].ISS_SOURCE;
      var sourceKey = Object.keys(ISS_SOURCE).filter(function (key) {
        return ISS_SOURCE[key].val === newObj[v];
      });

      if (sourceKey.length > 0) {
        newObj['Client-Id'] = ISS_SOURCE[sourceKey[0]].clientId;
      }
    }
  });
  (0, _defineProperty2["default"])(this, "_cookieHelper", {
    setItem: function setItem(key, value) {
      return _jsCookie["default"].set(key, value);
    },
    getItem: function getItem(key) {
      return _jsCookie["default"].get(key);
    },
    removeItem: function removeItem(key) {
      return _jsCookie["default"].remove(key);
    }
  });
  this.KEYS = {
    cityId: 'cityId',
    account: 'account',
    storeId: 'storeId',
    shopId: 'shopId',
    employeeId: 'employeeId',
    oaid: 'oaid',
    channel: 'channel',
    imei: 'imei',
    cityCode: 'cityCode',
    mobile: 'mobile',
    idfa: 'idfa',
    iss_source: 'iss_source',
    utmSource: 'utmSource',
    apiVersion: 'apiVersion',
    iss_from: 'iss_from',
    versionName: 'versionName',
    mobileType: 'mobileType',
    shansongId: 'shansongId',
    isApp: 'isApp',
    token: 'token',
    tokenType: 'tokenType'
  };
  this.cookieData = document.cookie;
  this.wxMiniProgram = window.navigator.userAgent.toLowerCase().match(/miniprogram/i) == 'miniprogram' || window.__wxjs_environment === 'miniprogram' || getQueryString('tokenType') === '2';
  var ua = window.navigator.userAgent.toLowerCase();
  var isApp = getQueryString('isApp');
  var shanSongApp = isApp || /shansongclient/i.test(ua) || window.sessionStorage.getItem('IOS_INIT_TAG');

  if (isApp) {
    var mobileType = getQueryString('mobileType');
    var iss_from = getQueryString('iss_from');

    if (mobileType === '00' || iss_from === 'ios') {
      window.sessionStorage.setItem('IOS_INIT_TAG', true);
    }
  }

  this.storage = shanSongApp ? window.localStorage : this.wxMiniProgram ? this._cookieHelper : window.sessionStorage;
  this.STORENAME = 'appQueryInfo';
  this.allowKey = Object.keys(this.KEYS).map(function (v) {
    return _this.KEYS[v];
  });

  this._init();
});

var _default = new WebViewConnect();

exports["default"] = _default;